// extracted by mini-css-extract-plugin
module.exports = {"table":"PackagesCost_table__frtiT","table__link":"PackagesCost_table__link__3haVw"};